// Configurator mode — add class to body when #configurator is in the URL
if (window.location.hash === '#configurator') {
    document.documentElement.classList.add('configurator-mode');
    document.body.classList.add('configurator-mode');
}

document.addEventListener("DOMContentLoaded", () => {
    const arrow = document.querySelector(".arrow-el");
    const selector = "li a[data-open-on-hover]";
    const headerEl = document.querySelector("header.shopify-section-group-header-group");
    let activeLink = null;

    const showArrow = () => (arrow.style.opacity = "1");
    const hideArrow = () => {
        arrow.style.opacity = "0";
        activeLink = null;
    };

    function positionArrowAtLink (link) {
        const rect = link.getBoundingClientRect();
        const x = rect.left + rect.width / 2 + window.scrollX;   // center of the link
        const y = rect.top + rect.height / 2 + window.scrollY;   // center of the link
        arrow.style.left = `${x}px`;
        arrow.style.top = `${y}px`;
    }

    // Recenter on resize/scroll while hovering the same link
    function keepCenteredIfActive () {
        if (activeLink) positionArrowAtLink(activeLink);
    }
    window.addEventListener("scroll", keepCenteredIfActive, { passive: true });
    window.addEventListener("resize", keepCenteredIfActive);

    // Attach to all eligible links
    document.querySelectorAll(selector).forEach(link => {
        link.addEventListener("mouseenter", () => {
            activeLink = link;           // set new active link
            positionArrowAtLink(link);   // center once
            showArrow();                 // reveal arrow
        });

        link.addEventListener("mouseleave", (e) => {
            // If moving to another eligible link, that link's mouseenter will reposition+show.
            // Only hide if the next element isn't another eligible link.
            console.log(link.getAttribute("aria-expanded"));
            const to = e.relatedTarget;
            if (!to || !to.closest(selector)) {
                if (link.getAttribute("aria-expanded") !== "true") {
                    hideArrow();
                }
            }
        });

        headerEl.addEventListener("mouseleave", (e) => {
            hideArrow();
        })
    });

    // As a safety net: hide the arrow if the pointer leaves the navigation entirely
    document.addEventListener("mouseover", (e) => {
        if (!e.target.closest(selector) && activeLink === null) {
            hideArrow();
        }
    });
});


const addToCart = (body, reload = true, autoclose = false, openMinicart = true, showToast = false) =>
    updateCart('add', body, reload, autoclose, openMinicart, showToast);

const changeCart = (body, reload = true, autoclose = false, openMinicart = true, showToast = false) =>
    updateCart('change', body, reload, autoclose, openMinicart, showToast);

const updateCart = async (type, body, reload = true, autoclose = false, openMinicart = true, showToast = false) => {
    const url = type === 'add'
        ? `${Shopify.routes.root}cart/add`
        : `${Shopify.routes.root}cart/change`;

    if (reload) {
        body.sections = body.sections || [];
        if (!body.sections.includes('mini-cart')) {
            body.sections.push('mini-cart');
        }
    }

    try {
        const response = await fetch(`${url}.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(body)
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const cartContent = await response.json();
        const productTitle = cartContent?.product_title || 'product';

        // Feed the dataLayer add tracking, which listens to variant:add (the native
        // product-form dispatches it; this covers the offer-pack / cross-sell paths).
        if (type === 'add') {
            document.documentElement.dispatchEvent(new CustomEvent('variant:add', {
                bubbles: true,
                detail: { items: cartContent.items || [cartContent], cart: cartContent }
            }));
        }

        if (showToast && window.themeVariables?.settings?.cartType === 'message') {
            document.dispatchEvent(new CustomEvent('toast:show', {
                detail: {
                    message: window.themeVariables.strings.addedToCart.replace('{{product_title}}', productTitle),
                    tone: 'success',
                    duration: 2500
                }
            }));
        }

        if (reload) {
            reloadMiniCart(cartContent, autoclose, openMinicart);
        }
    } catch (error) {
        console.error('Error updating cart:', error);
    }
};

const reloadMiniCart = (cartContent, autoclose, openMinicart) => {
    // Re-render the cart drawer (self-contained: it re-fetches its own section).
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

    // Open/close the cart drawer directly. The legacy `multidrawer:open`/`multidrawer:close`
    // events have no listener in the current theme — the drawer opens via its own API.
    const cartDrawer = window.themeVariables?.settings?.cartType === 'drawer'
        ? document.querySelector('cart-drawer')
        : null;

    if (openMinicart && cartDrawer && !cartDrawer.open) {
        cartDrawer.show();
    }

    if (autoclose && cartDrawer) {
        setTimeout(() => cartDrawer.hide(), 3000);
    }

    if (window.location.pathname === '/cart') {
        window.location.reload();
    }
};

window.addToCart = addToCart;
window.changeCart = changeCart;

// Optimistic remove animation — capture current height so CSS can collapse it.
document.addEventListener('line-item:will-change', (e) => {
    if (e.detail?.targetQuantity !== 0) return;
    const row = (e.composedPath?.() || []).find((n) => n?.tagName === 'LINE-ITEM') || e.target;
    if (!(row instanceof HTMLElement)) return;
    row.style.setProperty('--line-item-h', row.offsetHeight + 'px');
    row.offsetHeight; // force reflow so the start value is applied before the class
    row.classList.add('line-item--removing');
}, true);


(function () {
    const isLocalDev = ['127.0.0.1', 'localhost', 'www.percko.com'].includes(window.location.hostname);
    if (!isLocalDev) return;

    const originalDispatchEvent = EventTarget.prototype.dispatchEvent;
    EventTarget.prototype.dispatchEvent = function (event) {
        if(!event.type.includes('triggering-state') &&
            !event.type.startsWith('onsite-event')) {
            
            console.log(`Event dispatched: ${event.type}`, {
                event: event,
                element: this
            });
        }
        originalDispatchEvent.call(this, event);
    };
})();